module.exports = __webpack_public_path__ + "static/img/img01.c6fdf98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv001/img01.jpg
// module id = NIJt
// module chunks = 0